/** Resolve a promise but keep a minimum visible duration so reload feedback is perceptible. */
export async function minDelay(promise, ms = 200) {
  const start = Date.now();
  try {
    return await promise;
  } finally {
    const elapsed = Date.now() - start;
    if (elapsed < ms) await new Promise((r) => setTimeout(r, ms - elapsed));
  }
}

/** Dev-only logger for non-critical/background failures. No-op in production builds. */
export const logDev = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn("[AcquireLoop]", ...args);
  }
};
